/** Shared FOC product-tour → Notes feedback helpers. */

export {
  FOC_TOUR_LABEL_CMD_IC,
  FOC_TOUR_LABEL_CMD_LEGAL,
  FOC_TOUR_LABEL_CMD_LIAISON,
  FOC_TOUR_LABEL_CMD_PIO,
  FOC_TOUR_LABEL_CMD_SAFETY,
  FOC_TOUR_LABEL_COP_LAYERS,
  FOC_TOUR_LABEL_FSLTP,
  FOC_TOUR_LABEL_HUB_COP,
  FOC_TOUR_LABEL_IAP_FORMS,
  FOC_TOUR_LABEL_IAP_PREP_OPS,
  FOC_TOUR_LABEL_INCIDENT_ROSTER,
  FOC_TOUR_LABEL_INCIDENTS,
  FOC_TOUR_LABEL_INITIAL_RESPONSE,
  FOC_TOUR_LABEL_LOG,
  FOC_TOUR_LABEL_NOTIFICATIONS,
  FOC_TOUR_LABEL_OPS,
  FOC_TOUR_LABEL_ORG_WORKSPACE,
  FOC_TOUR_LABEL_PLANNING,
  FOC_TOUR_LABEL_PLANNING_P_COMMAND_STAFF,
  FOC_TOUR_LABEL_PLANNING_P_MEETING,
  FOC_TOUR_LABEL_PLANNING_P_MODEL,
  FOC_TOUR_LABEL_PLANNING_P_PREP_TACTICS,
  FOC_TOUR_LABEL_PLANNING_P_TACTICS_MEETING,
  FOC_TOUR_LABEL_PLANNING_P_TACTICS_WORKFLOW,
  FOC_TOUR_LABEL_PLANNING_PREP_MEETING,
  FOC_TOUR_LABEL_PLN_DEMOB,
  FOC_TOUR_LABEL_PLN_DOCS,
  FOC_TOUR_LABEL_PLN_PSC,
  FOC_TOUR_LABEL_PLN_RESOURCE,
  FOC_TOUR_LABEL_PLN_SITL,
  FOC_TOUR_LABEL_RES_MODEL,
  FOC_TOUR_LABEL_RES_213RR,
  FOC_TOUR_LABEL_RES_211,
  FOC_TOUR_LABEL_RES_214,
  FOC_TOUR_LABEL_DMOB,
  FOC_TOUR_LABEL_EXT,
  FOC_TOUR_LABEL_AI_IOC,
  FOC_TOUR_LABEL_AI_FOC,
  FOC_TOUR_LABEL_SITL_COP,
  FOC_TOUR_LABEL_TRANSITION,
  FOC_TOUR_LABEL_WS,
} from 'components/MapPage/focTourLabels';
/** Attribute on the popover link; value is the tour display label. */
export const FOC_TOUR_FEEDBACK_ATTR = 'data-foc-tour-feedback';

export function focFeedbackNoteTitle(tourLabel: string): string {
  return `FOC Feedback ${tourLabel}`;
}

/** Read tour label from the final focFeedback step's note-open link. */
export function focTourLabelFromFeedbackStep(
  steps: ReadonlyArray<{ id?: string; description: string }>
): string | null {
  const step = steps.find((entry) => entry.id === 'focFeedback');
  if (!step) return null;
  const match = step.description.match(
    new RegExp(`${FOC_TOUR_FEEDBACK_ATTR}="([^"]*)"`)
  );
  if (!match?.[1]) return null;
  return match[1].replace(/&quot;/g, '"').replace(/&amp;/g, '&');
}

/**
 * Centered final-step popover body with a link that opens Notes and creates
 * the feedback document. The link is not HTML-escaped so the data attribute
 * remains clickable; tourLabel is escaped inside the attribute value.
 */
export function focFeedbackPopoverHtml(tourLabel: string): string {
  const safeLabel = escapeHtml(tourLabel);
  const attrValue = escapeAttr(tourLabel);
  return [
    `<p>You have finished the <strong>${safeLabel}</strong> walkthrough.</p>`,
    '<p>Open your FOC feedback note for this tour to review step feedback, update the Met/Not met checklist, and add any extra comments. If you left feedback during the walkthrough, it is already in this note.</p>',
    `<p><a href="#" ${FOC_TOUR_FEEDBACK_ATTR}="${attrValue}">Open FOC Feedback note</a></p>`,
    '<p class="tw:text-xs">After editing, click <strong>Save</strong> in the note editor. You can also click Done to close this tour.</p>',
  ].join('');
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function escapeAttr(value: string): string {
  return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
}
